/* eslint-disable */
import * as React from 'react';
import { List } from 'immutable';
import Icon from '../Icon/Icon';
import ConfirmationBox from '../ConfirmationBox/ConfirmationBox.jsx';

import throttle from 'lodash/throttle';
import classNames from 'classnames';
import moment from 'moment';
import { LocalStorageState } from 'src/AppState/LocalStorageState/LocalStorageState';
import { TraderChatAssignee, TraderChatButton, TraderChatButtonsWrapper, TraderChatDeleteButton, TraderChatInputWrapper, TraderChatMessageAuthor, TraderChatMessageFooter, TraderChatMessageItem, TraderChatMessagesList, TraderChatSendButton, TraderChatTextArea, TraderChatWrapper } from './TraderChat.style';
import { InputWrapper } from 'src/domains/layouts/shared/formComponents/input/Input.style';

class TraderChat extends React.PureComponent {
    static defaultProps = {
        messages: List(),
    };

    constructor(props) {
        super(props);

        this.state = {
            message: '',
            height: 0,
            deleteMessageId: null,
        };

        this.sendTyping = throttle(
            (chatId) => {
                this.props.onTyping(chatId);
            },
            600,
            { trailing: false }
        );

        /**
         * @type {React.RefObject<HTMLUListElement>}
         */
        this.messagesListRef = React.createRef();

        /**
         * @type {React.RefObject<HTMLTextAreaElement>}
         */
        this.textareaRef = React.createRef();
    }

    UNSAFE_componentWillMount() {
        this.props.onGetChatRequest(this.props.chatId);
    }

    componentDidMount() {
        if (this.messagesListRef.current !== null) {
            this.messagesListRef.current.scrollTop = 9999999;
        }

        // Update messages sent time
        this.updateInterval = setInterval(() => this.forceUpdate(), 5000);

        const draft = this.props.localStorage.getChatDraft(this.props.chatId);

        if (draft) {
            this.setState({ message: draft }, () => {
                const element = this.textareaRef.current;
                this.calculateHeight(element);
            });
        }
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.isError != props.isError) {
            this.isError = props.isError;

            if (this.isError) {
                this.setState({
                    message: this.props.pending,
                });
            }
        }
    }

    UNSAFE_componentWillUpdate() {
        if (this.messagesListRef.current !== null) {
            const list = this.messagesListRef.current;
            this.scrolled = list.scrollTop + list.offsetHeight < list.scrollHeight;
        }
    }

    componentDidUpdate() {
        if (!this.scrolled) {
            if (this.messagesListRef.current !== null) {
                this.messagesListRef.current.scrollTop = 9999999;
            }
        }
    }

    componentWillUnmount() {
        this.props.onStopTyping(this.props.chatId);
        clearInterval(this.updateInterval);
    }

    handleMessage = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!this.state.message.trim().length) {
            return;
        }

        this.props.onSendMessageRequest(this.props.chatId, this.state.message);

        this.props.localStorage.clearChatDraft(this.props.chatId);

        this.setState({ message: '', height: 0 });
    };

    handleAssign = () => {
        this.props.onAssignChatRequest(this.props.chatId);
    };

    handleReassign = async () => {
        await $appState.trpcClient.reassignTraderChat(this.props.chatId);
        this.props.onGetChatRequest(this.props.chatId);
    };

    handleUnassign = () => {
        this.props.onUnassignChatRequest(this.props.chatId);
    };

    handleEnd = () => {
        this.props.onEndChatRequest(this.props.chatId);
    };

    /**
     * @param { React.ChangeEvent<HTMLTextAreaElement> } event
     */
    handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.handleMessage(event);
        }
    };

    /**
     * @param { React.ChangeEvent<HTMLTextAreaElement> } event
     */
    changeMessage = (event) => {
        const element = event.currentTarget;
        const value = element.value;

        this.setState(
            { message: value },
            () => this.calculateHeight(element)
        );

        const isTyping = value.trim() !== '';

        if (isTyping) {
            this.sendTyping(this.props.chatId);
        } else {
            this.props.onStopTyping(this.props.chatId);
        }

        this.props.localStorage.setChatDraft(this.props.chatId, value);
    };

    calculateHeight = (element) => {
        this.setState({ height: 'auto' }, () => {
            const newHeight = element.scrollHeight + 'px';
            this.setState({ height: newHeight });
        });
    };

    handleDeleteMessage = (messageId) => {
        this.setState({ deleteMessageId: messageId });
    };

    handleConfirmDelete = () => {
        const { chatId, onDeleteMessageRequest } = this.props;
        onDeleteMessageRequest(chatId, this.state.deleteMessageId);
        this.setState({ deleteMessageId: null });
    };

    handleRejectDelete = () => {
        this.setState({ deleteMessageId: null });
    };

    render() {
        const { messages, isUserTyping, isError, errors, assignee, accountId, permissions } = this.props;

        const messagesList = messages
            .filter((msg) => {
                return msg.get('type') === 'standard';
            })
            .map((message, idx) => {
                const ownMessage = message.get('sender').get('id') === accountId;

                const time = moment(message.get('sentAt')).fromNow();
                const author = ownMessage ? 'You' : message.get('sender').get('name');
                let content = message.get('content');

                if (typeof content !== 'string') {
                    content = content.get('text');
                }

                const canDelete = permissions && permissions.has('chat/delete-messages');
                const id = message.get('id');

                return (
                    <TraderChatMessageItem
                        key={id}
                        ownMessage={ownMessage}
                    >
                        {content}

                        <TraderChatMessageFooter>
                            <TraderChatMessageAuthor>
                                {author}
                                <span>, {time}</span>
                            </TraderChatMessageAuthor>

                            {canDelete && (
                                <TraderChatDeleteButton
                                    type='button'
                                    onClick={() => this.handleDeleteMessage(id)}
                                    data-test='delete-message-button'
                                >
                                    <Icon name='trashcan' />
                                </TraderChatDeleteButton>
                            )}
                        </TraderChatMessageFooter>
                    </TraderChatMessageItem>
                );
            });

        let typingMessage;
        if (isUserTyping) {
            typingMessage = (
                <TraderChatMessageItem ownMessage={false}>
                    <i>
                        <Icon name='pen' />
                    </i>
                </TraderChatMessageItem>
            );
        }

        let errorsList;

        if (isError) {
            errorsList = typeof errors === 'string' ? errors : errors.values().map((error) => <p>{error}</p>);

            errorsList = (
                <div className='element'>
                    <div className='error-message'>
                        <div className='error-message-content'>{errorsList}</div>
                    </div>
                </div>
            );
        }

        const assignedToMe = assignee && assignee.get('id') === accountId;
        let assignButton, unassignButtons;

        if (assignedToMe) {
            unassignButtons = (
                <TraderChatButtonsWrapper>
                    <TraderChatButton
                        type='button'
                        onClick={this.handleUnassign}
                        data-test='unassign-button'
                    >
                        Unassign
                    </TraderChatButton>
                    <TraderChatButton
                        type='button'
                        onClick={this.handleEnd}
                        data-test='end-button'
                    >
                        End
                    </TraderChatButton>
                </TraderChatButtonsWrapper>
            );
        } else if (!assignee) {
            assignButton = (
                <TraderChatButtonsWrapper>
                    <TraderChatButton
                        type='button'
                        onClick={this.handleAssign}
                        data-test='assign-to-me-button'
                    >
                        Assign to me
                    </TraderChatButton>
                </TraderChatButtonsWrapper>
            );
        }

        let assigneeInfo;
        let reassignButton;

        if (assignee) {
            const name = assignedToMe ? 'you' : assignee.get('name');

            assigneeInfo = (
                <TraderChatAssignee data-test='trader-chat-assignee-header'>
                    Assigned to <strong>{name}</strong>
                </TraderChatAssignee>
            );
        }

        if (assignee && assignedToMe === false) {
            reassignButton = (
                <TraderChatButtonsWrapper>
                    <TraderChatButton
                        type='button'
                        onClick={this.handleReassign}
                        data-test='reassign-to-me-button'
                    >
                        Reassign to me
                    </TraderChatButton>
                </TraderChatButtonsWrapper>
            );
        }

        return (
            <TraderChatWrapper>
                {assigneeInfo}

                <TraderChatMessagesList
                    ref={this.messagesListRef}
                    hasAssignee={!!assignee}
                >
                    {messagesList}

                    {typingMessage}
                </TraderChatMessagesList>

                <form
                    method='POST'
                    onSubmit={this.handleMessage}
                >
                    <TraderChatInputWrapper>
                        <TraderChatTextArea
                            ref={this.textareaRef}
                            type='text'
                            value={this.state.message}
                            onChange={this.changeMessage}
                            onKeyDown={this.handleKeyDown}
                            data-test='chat-input'
                            height={this.state.height}
                        />
                        <TraderChatSendButton
                            type='submit'
                            data-test='send-button'
                        >
                            Send
                        </TraderChatSendButton>
                    </TraderChatInputWrapper>

                    {errorsList}

                    {assignButton}
                    {unassignButtons}
                    {reassignButton}
                </form>

                {this.state.deleteMessageId !== null && (
                    <ConfirmationBox
                        message='Are you sure you want to delete this message?'
                        onConfirm={this.handleConfirmDelete}
                        onReject={this.handleRejectDelete}
                    />
                )}
            </TraderChatWrapper>
        );
    }
}

export default TraderChat;
